import { useTranslation } from 'react-i18next';

import { Select } from '@cfa/react-core';

import { countries } from '../../countries';
import { useFocusAdminState } from '../../state';

import { TranslationKey } from '@/i18n';

const ManagingCountry: React.FC = () => {
  const { t } = useTranslation();
  const { selectedCountry, setSelectedCountry } =
    useFocusAdminState('selectedCountry');

  return (
    <div className="mb-12">
      <Select.Root
        data-testid="AdminManageCountryDropDownMenu"
        className="w-[256px]"
        selectedKey={selectedCountry.id}
        onSelectionChange={key => {
          const country = countries.find(country => country.id === key);
          if (country) {
            setSelectedCountry(country);
          }
        }}
      >
        <Select.Label className="text-base/6! font-normal! uppercase!">
          {t('Admin.managingCountry')}
        </Select.Label>
        <Select.Button>
          <Select.Value className="font-bold!" />
        </Select.Button>
        <Select.Popover>
          <Select.List>
            {countries.map(country => (
              <Select.Item
                key={country.id}
                id={country.id}
                data-testid={`AdminManageCountryDropDownMenu-${country.label}`}
              >
                {t(`Admin.${country.label}` as TranslationKey)}
              </Select.Item>
            ))}
          </Select.List>
        </Select.Popover>
      </Select.Root>
    </div>
  );
};

export default ManagingCountry;
